export default "__VITE_ASSET__n5edlP0r__"